import * as i0 from '@angular/core';
import { Injectable, NgModule, Optional } from '@angular/core';
import { HttpUrlEncodingCodec, HttpParams } from '@angular/common/http';

const DEFAULTS$1 = {
    frameOptions: {
        none: true,
    },
    url: 'https://host.nxt.blackbaud.com/',
};
/**
 * Host configuration for components and applications.
 * @deprecated Use `SkyAppConfig.skyux.host` instead.
 */
class SkyAppConfigHost {
    get host() {
        return this.#_host;
    }
    #_host;
    init(config) {
        this.#_host = {
            ...DEFAULTS$1,
            ...(config || {}),
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigHost, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigHost }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigHost, decorators: [{
            type: Injectable
        }] });

const DEFAULTS = {
    envid: {
        required: false,
    },
    leid: {
        required: false,
    },
    svcid: {
        required: false,
    },
};
/**
 * @deprecated Use `SkyAppConfig.skyux.params` instead.
 */
class SkyAppConfigParams {
    get params() {
        return this.#_params;
    }
    #_params;
    init(params) {
        this.#_params = {
            ...DEFAULTS,
            ...(params || {}),
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigParams, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigParams }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigParams, decorators: [{
            type: Injectable
        }] });

/**
 * @deprecated Provide `SkyAppConfig` at the root instead.
 */
class SkyAppConfigModule {
    static forRoot(config = {}) {
        return {
            ngModule: SkyAppConfigModule,
            providers: [
                {
                    provide: SkyAppConfigParams,
                    useFactory() {
                        const appConfigParams = new SkyAppConfigParams();
                        appConfigParams.init(config.params);
                        return appConfigParams;
                    },
                },
                {
                    provide: SkyAppConfigHost,
                    useFactory() {
                        const appConfigHost = new SkyAppConfigHost();
                        appConfigHost.init(config.host);
                        return appConfigHost;
                    },
                },
            ],
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfigModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

class SkyuxPactConfig {
}
class SkyAppConfig {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfig, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfig }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppConfig, decorators: [{
            type: Injectable
        }] });

/**
 * Override Angular's default encoder because it excludes certain characters.
 * @see https://github.com/angular/angular/blob/cb31dbc75ca4141d61cec3ba6e60505198208a0a/packages/common/http/src/params.ts#L96-L111
 */
class UrlEncoder extends HttpUrlEncodingCodec {
    encodeKey(key) {
        return encodeURIComponent(key);
    }
    encodeValue(key) {
        return encodeURIComponent(key);
    }
}
/**
 * Given a "url" (could be just querystring, or fully qualified),
 * Returns the extracted HttpParams.
 */
function getUrlSearchParams(url) {
    let qs = '';
    if (url.indexOf('?') > -1) {
        qs = url.split('?')[1];
        qs = qs.split('#')[0];
    }
    return new HttpParams({
        encoder: new UrlEncoder(),
        fromString: qs,
    });
}
class SkyAppRuntimeConfigParams {
    #params = {};
    #defaultParamValues = {};
    #requiredParams = [];
    #encodedParams = [];
    #excludeFromLinksParams = new Set();
    #excludeFromRequestsParams = new Set();
    constructor(url, configParams) {
        const allowed = [];
        for (const paramName of Object.keys(configParams)) {
            const configParam = configParams[paramName];
            // The config param could be present but be set to false/undefined indicating
            // an override of the default parameter.
            if (configParam) {
                allowed.push(paramName);
                // A boolean value may be present to simply indicate that a parameter is allowed.
                // If the type is object, look for additional config properties.
                if (typeof configParam === 'object') {
                    const paramValue = configParam.value;
                    if (configParam.required) {
                        this.#requiredParams.push(paramName);
                    }
                    if (paramValue) {
                        this.#params[paramName] = paramValue;
                        this.#defaultParamValues[paramName] = paramValue;
                    }
                    if (configParam.excludeFromLinks) {
                        this.#excludeFromLinksParams.add(paramName);
                    }
                    if (configParam.excludeFromRequests) {
                        this.#excludeFromRequestsParams.add(paramName);
                    }
                }
            }
        }
        const httpParams = getUrlSearchParams(url);
        // Get uppercase keys.
        const allowedKeysUC = allowed.map((key) => key.toUpperCase());
        const urlSearchParamKeys = Array.from(httpParams.keys());
        // Filter to allowed params and override default values.
        urlSearchParamKeys.forEach((givenKey) => {
            const givenKeyUC = givenKey.toUpperCase();
            allowedKeysUC.forEach((allowedKeyUC, index) => {
                if (givenKeyUC === allowedKeyUC) {
                    const param = httpParams.get(givenKey);
                    if (param) {
                        this.#params[allowed[index]] = param;
                        this.#encodedParams.push(givenKey);
                    }
                }
            });
        });
    }
    /**
     * Does the key exist
     */
    has(key) {
        return Object.prototype.hasOwnProperty.call(this.#params, key);
    }
    /**
     * Are all the required params defined?
     */
    hasAllRequiredParams() {
        if (this.#requiredParams.length === 0) {
            return true;
        }
        return this.#requiredParams.every((param) => {
            return this.#params[param] !== undefined;
        });
    }
    /**
     * Returns a flag indicating whether a parameter is required.
     */
    isRequired(key) {
        return this.#requiredParams.indexOf(key) >= 0;
    }
    /**
     * Returns the decoded value of the requested param.
     * @param key The parameter's key.
     */
    get(key) {
        if (this.has(key)) {
            return this.#params[key];
        }
        return;
    }
    /**
     * Returns the params object.
     * @param excludeDefaults Exclude params that have default values
     */
    getAll(excludeDefaults) {
        const filteredParams = {};
        this.getAllKeys().forEach((key) => {
            if (!excludeDefaults ||
                this.#params[key] !== this.#defaultParamValues[key]) {
                filteredParams[key] = this.#params[key];
            }
        });
        return filteredParams;
    }
    /**
     * Returns all keys for current params.
     */
    getAllKeys() {
        return Object.keys(this.#params);
    }
    /**
     * Adds the current params to the supplied URL.
     */
    getUrl(url) {
        return this.#buildUrlWithParams(url, this.#excludeFromRequestsParams);
    }
    /**
     * Adds the current params to the supplied link URL.
     * @param url The url to update.
     * @param queryParams Optional query parameters to include in the constructed url.
     */
    getLinkUrl(url, options) {
        return this.#buildUrlWithParams(url, new Set([
            ...this.#excludeFromRequestsParams,
            ...this.#excludeFromLinksParams,
        ]), options?.queryParams);
    }
    #buildUrlWithParams(url, excludeParams, queryParams) {
        const urlParams = getUrlSearchParams(url);
        // Determine if the url params need to be modified.
        const urlParamsRequireModification = urlParams
            .keys()
            .some((key) => excludeParams.has(key) || queryParams?.[key]);
        const [beforeFragment, fragment] = url.split('#', 2);
        const root = urlParamsRequireModification
            ? beforeFragment.split('?')[0]
            : beforeFragment;
        let unifiedParams = urlParamsRequireModification
            ? urlParams
            : getUrlSearchParams('');
        // Remove excluded params.
        if (urlParamsRequireModification) {
            for (const paramName of excludeParams.keys()) {
                unifiedParams = unifiedParams.delete(paramName);
            }
        }
        // Add provided parameters to the URL.
        if (queryParams) {
            for (const [paramName, decodedValue] of Object.entries(queryParams)) {
                if (decodedValue !== undefined) {
                    unifiedParams = unifiedParams.set(paramName, decodedValue);
                }
            }
        }
        // Respect pre-existing params which already have values.
        for (const key of this.getAllKeys()) {
            if (!excludeParams.has(key) &&
                !urlParams.has(key) &&
                !unifiedParams.has(key)) {
                const decodedValue = this.get(key);
                if (decodedValue) {
                    unifiedParams = unifiedParams.append(key, decodedValue);
                }
            }
        }
        // Combine all requested parameters and their values, e.g. 'a=b'.
        const joinedParams = unifiedParams.toString();
        const delimiter = root.includes('?') ? '&' : '?';
        // Build and return the final URL.
        return (root +
            (joinedParams.length === 0 ? '' : `${delimiter}${joinedParams}`) +
            (fragment ? `#${fragment}` : ''));
    }
}

/**
 * Provides methods to interact with runtime config query parameters.
 * @deprecated Use `SkyAppConfig.runtime.params` instead.
 */
class SkyAppRuntimeConfigParamsProvider {
    get params() {
        return this.#_params;
    }
    #_params;
    constructor(configParams) {
        this.#_params = new SkyAppRuntimeConfigParams(window.location.href, configParams?.params || {});
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppRuntimeConfigParamsProvider, deps: [{ token: SkyAppConfigParams, optional: true }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppRuntimeConfigParamsProvider, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.9", ngImport: i0, type: SkyAppRuntimeConfigParamsProvider, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: SkyAppConfigParams, decorators: [{
                    type: Optional
                }] }]; } });

/**
 * Generated bundle index. Do not edit.
 */

export { SkyAppConfig, SkyAppConfigHost, SkyAppConfigModule, SkyAppConfigParams, SkyAppRuntimeConfigParams, SkyAppRuntimeConfigParamsProvider, SkyuxPactConfig };
